import { useParams } from 'react-router-dom'
import { NotExistEntity } from 'shared/errors'

import { api } from '../api'

function useCurrent() {
	const { id = '' } = useParams<{ id: string }>()

	const { data: campaign, ...query } = api.useGetCampaignsByIdQuery(id, {
		skip: !id
	})

	return { campaign, id, ...query }
}

function useValidId() {
	const { campaign, id, isSuccess } = useCurrent()

	// Server response is 204 with no content
	const invalidId = isSuccess && typeof campaign === 'string'

	if (!id || invalidId) {
		throw new NotExistEntity('Imports with that id not exist')
	}
}

export { useCurrent, useValidId }
